<template>
  <div class="has-bg-white is-border task"
    @mouseover="hoverCard(true, 0)"
    @mouseout="hoverCard(false, 50)"
  >
    <div class="columns">
      <div class="column is-narrow is-margin-top-xsmall is-padding-top-small is-padding-bottom-xsmall">
        <span class="avatar">
            <span class="has-bg-danger has-text-white">
                <i class="fal fa-alarm-clock fa-lg"></i>
            </span>
        </span>
      </div>
      <div class="column is-paddingless-left is-padding-top-small is-padding-bottom-xsmall">
        <p class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xsmall">
          <span v-if="isToday">Aujourd’hui à {{date | dtFormat('HH[h]mm')}}</span>
          <span v-else>{{date | prettyDatetime}}</span>
        </p>
        <p class="is-size-4">
          <strong>RAPPEL : </strong>
          <span v-if="customInfos">
            <router-link v-if="customInfos.adv" :to="{name: 'AdvInfos', params: {id: customInfos.adv}}" class="is-uppercase">
              ADV {{customInfos.adv_ref}}
            </router-link>
          </span>
          <span v-else>
            <router-link :to="{name: 'CalendarDayView', query: {day: date.date(), month: date.month() + 1, year: date.year(), panel: 'REMINDERS'}}" class="is-uppercase">
              {{reminder.title | cap}}
            </router-link>
          </span>
          <span v-if="selfReminder">&nbsp;</span>
        </p>
        <div class="columns is-gapless is-multiline">
          <div v-if="customInfos && customInfos.buyer"
               class="column is-6 is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
            <router-link :to="{name: 'ContactVue', params: {id: customInfos.buyer}}">
              <span class="has-text-grey">Client :</span><br><span class="is-hover-underline">{{customInfos.buyer_name}}</span>
            </router-link>
          </div>
          <div v-if="customInfos && customInfos.buyer_info"
               class="column is-6 is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
            <span class="has-text-grey">Coordonnées :</span><br>{{customInfos.buyer_info}}
          </div>
          <div v-if="!selfReminder"
               class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge is-size-6">
            <router-link :to="{name: 'UserVue', params: {id: reminder.user}}">
              <span class="has-text-grey">Vendeur :</span><br><span class="is-hover-underline">{{reminder.user_name}}</span>
            </router-link>
          </div>
          <div class="column is-12 is-padding-top-xsmall is-padding-bottom-xsmall" v-if="customInfos">
            <span class="is-size-6 has-text-grey">Objet :</span>
            <div class="is-size-5">{{reminder.title | cap}}</div>
          </div>
          <div v-if="reminder.note"
               class="column is-12 is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xlarge">
            <span class="has-text-grey is-size-6">Note :</span>
            <div class="is-size-5 is-break-word">{{reminder.note}}</div>  
          </div>
        </div>
      </div>
      <div class="column is-narrow w40p is-paddingless">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
          :duration="{ enter: 120, leave: 120 }"
          mode="out-in"
        >
          <button @click="removeReminder"
            v-show="isHover"
            class="button is-light is-size-7 is-min-width-0 is-radiusless is-height-full w100 tooltip is-tooltip-left has-text-grey is-border-left"
            data-tooltip="Supprimer">
            <span class="icon is-small"><i class="fas fa-times"></i></span>
          </button>
        </transition>
      </div>
    </div>
    <!--<div key="buttons"
         class="column is-paddingless-top is-paddingless-bottom is-border-top is-border-dashed task-footer">
      <button @click="removeReminder" class="button is-white is-size-7 is-height-4 is-min-width-0">
        Supprimer
      </button>
    </div>-->
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { isEmpty } from 'lodash'

  export default {
    name: 'ReminderCard',
    props: {
      reminder: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        isHover: false,
        w: window,
        ticking: false,
        timer: null
      }
    },
    computed: {
      ...mapGetters(['currentUserPk']),
      isToday () {
        return this.date.isSame(moment(), 'day')
      },
      selfReminder () {
        return this.reminder.user === this.currentUserPk
      },
      date () {
        return moment(this.reminder.date)
      },
      customInfos () {
        if (this.reminder && this.reminder.custom_fields && !isEmpty(this.reminder.custom_fields)) {
          return this.reminder.custom_fields
        }
      }
    },
    methods: {
      removeReminder () {
        this.$api.reminderService.delete(this.reminder.pk).catch(err => {
          console.log(err)
        })
      },
      hoverCard (isHover, delay = 100) {
        if (this.isHover === isHover) {
          this.w.clearTimeout(this.timer)
          this.isHover = isHover
          this.ticking = false
        } else if (!this.ticking) {
          // Si on quitte le card alors on met un delais avant la disparition du hover
          this.timer = this.w.setTimeout(() => {
            this.isHover = isHover
            this.ticking = false
          }, delay)
          this.ticking = true
        }
      }
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/event-card/ReminderCard.vue